export function LogoMark({ compact = false }: { compact?: boolean }) {
  return (
    <span className={`logo-lockup${compact ? " logo-lockup--compact" : ""}`}>
      <img
        className="logo-art"
        src="/brand/bubblefun-logo.png"
        width="40"
        height="40"
        alt=""
        decoding="async"
        fetchPriority="high"
      />
      {!compact && <span className="logo-word">Bubble <span>Hood</span></span>}
    </span>
  );
}
